import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { CustomerProfile } from "@/types";

interface AuthState {
  user: CustomerProfile | null;
  registerToken: string | null;
  setUser: (user: CustomerProfile) => void;
  setRegisterToken: (token: string) => void;
  clearRegisterToken: () => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      registerToken: null,

      setUser: (user) => set({ user }),

      setRegisterToken: (registerToken) => set({ registerToken }),

      clearRegisterToken: () => set({ registerToken: null }),

      clearAuth: () => set({ user: null, registerToken: null }),
    }),
    {
      name: "fast-auth",
      partialize: (state) => ({
        user: state.user,
        registerToken: state.registerToken,
      }),
    }
  )
);
